.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.select {
  appearance: none;
  height: 34px;
  padding: 0 30px 0 var(--space-3);
  background: var(--bg-inset);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--text-sm);
  cursor: pointer;
  transition: border-color var(--duration-fast) var(--ease-out);
}

.select:hover {
  border-color: var(--border-strong);
}

.select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-subtle);
}

.chevron {
  position: absolute;
  right: 9px;
  color: var(--text-tertiary);
  pointer-events: none;
}
